<template>
  <div class="face-images">
    <BigImg
      v-for="(item, index) in dataSource"
      :key="index"
      :url="item.access_url"
    />
  </div>
</template>
<script>
import BigImg from "@/components/PublicModals/BigImg";
export default {
  components: {
    BigImg,
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      confirmLoading: false,
      previewVisible: false,
      previewImage: this.url || "",
    };
  },
  methods: {
    closeBig() {
      this.previewVisible = false;
    },
    hanldeImg() {
      if (!this.url) return;
      this.previewVisible = true;
    },
    back(data) {
      this.$emit("uploadOk", data);
    },
  },
};
</script>
<style lang="less">
.face-images {
  display: flex;
  .big-images {
    margin: 0 3px;
  }
}
</style>
